import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";

export const formulariFormDatiQuantita: AnaColumn[] = [
    {
      itemType: "group", groupDataField: '', caption: 'Quantità Rifiuto', colCount: "2", data: [
  
  
        {
          type: 'campo', colVisible: false, dataField: 'denominazioneFirmatario', hideOnEdit: true, caption: 'denominazioneFirmatario',
          width: 45 * aspect,
          maxLength: '40',
  
  
        },
        {
          type: 'campo', colVisible: false, dataField: 'identificativoFirmatario', dataType: "", hideOnEdit: true, caption: 'identificativoFirmatario',
          width: 15 * aspect,
          maxLength: '10',
  
  
        },
        {
          type: 'campo', colVisible: false, dataField: 'tipoFirma', dataType: "", hideOnEdit: true, caption: 'tipoFirma',
          width: 15 * aspect,
          maxLength: '10',
  
  
        },
  
  
        {
          type: 'campo', colVisible: false, dataField: 'valore', dataType: "number", hideOnEdit: false, caption: 'Quantità',
          width: 15 * aspect,
          maxLength: '10',
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
  
        },
        {
          type: 'campo', colVisible: false, dataField: 'pesolordo', dataType: "number", caption: 'Peso lordo', hideOnEdit: false,
          width: 15 * aspect,
          maxLength: '10',
        },
        {
          type: 'campo', colVisible: false, dataField: 'tara', dataType: "number", hideOnEdit: false,
          width: 15 * aspect,
          maxLength: '10',
        },
        {
          type: 'campoSpecial', colVisible: false, dataField: 'um', dataType: "", hideOnEdit: false, caption: 'Unità misura',
          editorType: 'dxSelectBox',
          lista: {
            dataSource: 'um',
            valueExpr: 'id',
            displayExpr: 'descrizione',
            static: true
          },
          width: 15 * aspect,
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
        },
  
        { type: 'campo', colVisible: false, dataField: 'verificareADestino', dataType: "boolean", editorType: 'dxCheckBox', caption: 'Verificare a destino', hideOnEdit: false },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", editorType: '', caption: '', hideOnEdit: false },
  
      ]
    }
  
  ]